import * as Headless from '@headlessui/react';
import { ReactNode } from 'react';
import Text from '@/components/Text';
import cn from '@/utils/cn';
import isString from '@/utils/typeGuards/isString';

type TProps = {
  children: ReactNode;
  className?: string;
  shouldLocalize?: boolean;
} & Omit<Headless.DescriptionProps, 'as' | 'className'>;

export const ErrorMessage = ({
  children,
  className,
  shouldLocalize = true,
  ...props
}: TProps) => {
  return (
    <Headless.Description
      data-slot="error"
      {...props}
      className={cn(
        className,
        'text-secondary-red text-sm data-disabled:opacity-50 sm:text-sm/6'
      )}
    >
      {shouldLocalize && isString(children) ? (
        <Text>{children}</Text>
      ) : (
        children
      )}
    </Headless.Description>
  );
};
